/**
 * For actions on public pages that need an account (add to basket, share, follow):
 * remembers where the shopper was so /login can send them back afterwards.
 * A no-op when login is turned off (the API acts as the demo shopper).
 */
export function useRequireLogin() {
  const { authEnabled } = useRuntimeConfig().public
  const user = useSupabaseUser()
  const route = useRoute()
  const redirect = useSupabaseCookieRedirect()

  return async function requireLogin(returnTo?: string): Promise<boolean> {
    if (!authEnabled || user.value) return true
    redirect.path.value = returnTo ?? route.fullPath
    await navigateTo('/login')
    return false
  }
}
